module.exports = __webpack_public_path__ + "static/media/link-logo-invex.571c0548.jpg";